import { render, staticRenderFns } from "./PromotionAccessoryHistoryDetail.vue?vue&type=template&id=86a46220"
import script from "./PromotionAccessoryHistoryDetail.vue?vue&type=script&lang=js"
export * from "./PromotionAccessoryHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports